export const ivaTypeCodes = {
  OTHERS_SVO: 'OTHERS_SVO'
}
